module.exports = __webpack_public_path__ + "static/media/frosty-head.92e8404b.svg";